import { useLanguage } from '../../contexts/language';

import styles from './style.module.css';

// What a screen shows instead of its content when reading it failed, drawn
// as the blueprint's "Errors keep the work" alert: what happened, that what
// was saved is safe, and Try again, which reads the screen again in place
// without reloading the page. title replaces the headline when what failed
// is not the whole page.
export function LoadFailed({ title, onRetry }) {
  const { text } = useLanguage();
  let headline = text.loadFailed;

  if (typeof title === 'string') {
    headline = title;
  }

  return (
    <div className={ styles.alert } role='alert'>
      <span className={ styles.icon } aria-hidden='true'></span>

      <div className={ styles.lines }>
        <p className={ styles.text }><b>{ headline }</b> { text.loadFailedIntro }</p>

        <button className={ styles.retry } type='button' onClick={ onRetry }>{ text.tryAgain }</button>
      </div>
    </div>
  );
}
